import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class ProductWaitlistService {
  fetchProductWaitlist = params => {
    return fetch(config.config.endpointUrls.fetchProductWaitlist(params), {
      method: 'GET'
    })
  }

  addToProductWaitlist = params => {
    return fetch(config.config.endpointUrls.addToProductWaitlist(), {
      method: 'POST',
      body: params
    })
  }

  deleteFromProductWaitlist = id => {
    return fetch(config.config.endpointUrls.deleteFromProductWaitlist(id), {
      method: 'DELETE'
    })
  }

  addToCustomerProductWaitlist = ({ productIds, customerId, storeId, replace }) => {
    return fetch(config.config.endpointUrls.addToCustomerProductWaitlist({ customerId, storeId, replace }), {
      method: 'POST',
      body: productIds
    })
  }
}

export default new ProductWaitlistService()



// WEBPACK FOOTER //
// ../src/services/productWaitlistService/productWaitlistService.js